import Service from "../../Service";

const resource = "HmnCandidateProcess/";

export default {
  save(item, requestID) {
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
  updateStatus(CprID, CprStatus, Observation, requestID) {
    console.log("Actualizando estado del candidato", { CprID, CprStatus, Observation, requestID });
    
    return Service.post(resource + "updateStatus", {}, {
      params: { CprID: CprID, CprStatus: CprStatus, Observation: Observation, requestID: requestID },
    });
  },
  advanceStage(CprID, NextStageID, Observation, requestID) {
    return Service.post(resource + "advanceStage", {}, {
      params: { CprID: CprID, NextStageID: NextStageID, Observation: Observation, requestID: requestID },
    });
  },
  stageHistory(CprID, requestID) {
    return Service.post(resource + "stageHistory", null, {
      params: { CprID: CprID, requestID: requestID },
    });
  },
  saveInterviewResponses(CprID, ResponsesJSON, requestID) {
    return Service.post(resource + "saveInterviewResponses", {}, {
      params: { CprID: CprID, ResponsesJSON: ResponsesJSON, requestID: requestID },
    });
  },
  getInterviewResponses(CprID, requestID) {
    return Service.post(resource + "getInterviewResponses", null, {
      params: { CprID: CprID, requestID: requestID },
    });
  },
  bossApprovalList(PstResponsibleID, IsAdmin, requestID) {
    return Service.post(resource + "bossApprovalList", null, {
      params: {
        PstResponsibleID: PstResponsibleID,
        IsAdmin: IsAdmin,
        requestID: requestID,
      },
    });
  },
  setStartDate(payload, requestID) {
    return Service.post(resource + "setStartDate", payload, {
      params: { requestID: requestID },
    });
  },
  setCostContract(CprID, TypeCost, TypeContract, CprSalary, requestID) {
    return Service.post(resource + "setCostContract", {}, {
      params: { CprID, TypeCost, TypeContract, CprSalary, requestID },
    });
  },
  welcomeData(CprID, requestID) {
    return Service.post(resource + "welcomeData", null, {
      params: { CprID: CprID, requestID: requestID },
    });
  },
  prepareWelcomeEmail(payload, requestID) {
    return Service.post(resource + "prepareWelcomeEmail", payload, {
      params: { requestID: requestID },
    });
  },
  setNotificationSent(payload, requestID) {
    return Service.post(resource + "setNotificationSent", payload, {
      params: { requestID: requestID },
    });
  },
  welcomeAssets(requestID) {
    return Service.post(resource + "welcomeAssets", null, {
      params: { requestID: requestID },
    });
  },
  prepareRejectionEmail(payload, requestID) {
    return Service.post(resource + "prepareRejectionEmail", payload, {
      params: { requestID: requestID },
    });
  },
  getRejectionAssets(requestID) {
    return Service.post(resource + "rejectionAssets", null, {
      params: { requestID: requestID },
    });
  },
  getArchiveAssets(requestID) {
    return Service.post(resource + "archiveAssets", null, {
      params: { requestID: requestID },
    });
  },
  setReadyForBoss(CprID, IsReady, requestID) {
    return Service.post(resource + "setReadyForBoss", {}, {
      params: { CprID: CprID, IsReady: IsReady, requestID: requestID },
    });
  },
  getWaitingForBoss(RprID, requestID) {
    return Service.post(resource + "getWaitingForBoss", null, {
      params: { RprID: RprID, requestID: requestID },
    });
  },
  getFilesByRprID(RprID, requestID) {
    return Service.post(resource + "getFilesByRprID", null, {
      params: { RprID: RprID, requestID: requestID },
    });
  },
  assignFileBatch(RprID, candidateIDs, requestID) {
    return Service.post(
      resource + "assignFileBatch",
      {
        RprID: RprID,
        CandidateIDs: candidateIDs,
      },
      {
        params: { requestID: requestID },
      },
    );
  },
  getLastByPrsID(PrsID, requestID, RprID = 0) {
    return Service.post(resource + "getLastByPrsID", null, {
      params: { PrsID: PrsID, RprID: RprID, requestID: requestID },
    });
  },
  promotionChecklist(CprID, requestID) {
    return Service.post(resource + "promotionChecklist", null, {
      params: { CprID: CprID, requestID: requestID },
    });
  },
  savePromotionChecklist(payload, requestID) {
    return Service.post(resource + "savePromotionChecklist", payload, {
      params: { requestID: requestID },
    });
  },
  promotionFiles(CprID, requestID) {
    return Service.post(resource + "promotionFiles", null, {
      params: { CprID: CprID, requestID: requestID },
    });
  },
  savePromotionFile(payload, requestID) {
    return Service.post(resource + "savePromotionFile", payload, {
      params: { requestID: requestID },
    });
  },
  deletePromotionFile(CpfID, requestID) {
    return Service.post(resource + "deletePromotionFile", null, {
      params: { CpfID: CpfID, requestID: requestID },
    });
  },
  calendarMeeting(payload, requestID) {
    return Service.post(resource + "calendarMeeting", payload, {
      params: { requestID: requestID },
    });
  },
  calendarMeetingByCprID(CprID, requestID) {
    return Service.post(resource + "calendarMeetingByCprID", null, {
      params: { CprID: CprID, requestID: requestID },
    });
  },
};
